export const CONTEXT_TAB = "0"
export const QUESTIONS_TAB = "1"
export const SUGGESTED_VIEWS_TAB = "2"
export const MY_VIEWS_TAB = "3"
export const DOCUMENTS_TAB = "4"
